import AutoComplete from '@tarekraafat/autocomplete.js';
import {categoriesData} from '../../../../pagesData.js';

export default class Search {
    constructor() {
        this.searchButton = document.querySelector('[data-search="button"]');
        this.searchInput = document.querySelector('[data-search="input"]');
        this.wrapper = document.querySelector('[data-search="wrapper"]');
        this.isSearchByArticles = import.meta.env.VITE_SITE_SEARCH_BY === 'articles';
        this.searchData = this.createSearchData();
        this.autoComplete = null;
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initAutoComplete();
            this.initListeners();
        });
    }

    createSearchData() {
        let searchData = [];

        categoriesData.forEach(cat => {
            if (this.isSearchByArticles) {
                for (let article in cat.articles) {
                    searchData.push({
                        name: article,
                        label: cat.articles[article],
                        category: cat.name,
                        type: 'article',
                    });
                }
            }
            searchData.push({
                name: cat.name,
                label: cat.label,
                category: cat.name,
                type: 'category',
            });
        });

        return searchData;
    }

    initAutoComplete() {
        this.autoComplete = new AutoComplete({
            selector: () => this.searchInput,
            placeHolder: this.isSearchByArticles ? 'Search category or article...' : 'Search category...',
            threshold: 2,
            data: {
                src: this.searchData.sort((a, b) => a.label > b.label),
                keys: ['label'],
                cache: true
            },
            resultItem: {
                highlight: 'autoComplete_highlight',
                selected: 'autoComplete_selected'
            },
            resultsList: {
                element: (list, data) => {
                    if (!data.results.length) {
                        // Create "No Results" message element
                        const message = document.createElement("li");
                        // Add class to the created element
                        message.setAttribute("class", "no_results");
                        // Add message text content
                        message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
                        // Append message element to the results list
                        list.prepend(message);
                    }
                },
                noResults: true,
            },
            searchEngine: 'loose',
        });
    }

    getLinkUrl(value) {
        const location = window.location;
        const linkPrefix = location.origin + location.pathname + 'categories/';
        return value.type === 'article'
            ? linkPrefix + `${value.category}/articles/${value.name}/`
            : linkPrefix + `${value.name}/`;
    }

    closeAutocompleteList() {
        this.autoComplete?.close();
        this.searchInput.value = '';
    }

    toggleSearchField() {
        this.wrapper?.classList.toggle('_opened');
        this.searchButton?.classList.toggle('_opened');

        setTimeout(() => {
            this.wrapper?.classList.contains('_opened')
                ? this.searchInput?.focus()
                : this.closeAutocompleteList();
        }, 100);
    }

    initListeners() {
        this.searchButton?.addEventListener('click', () => this.toggleSearchField());

        this.searchInput?.addEventListener('selection', ({detail}) => {
            this.toggleSearchField();
            if (!detail?.selection?.value) {
                return;
            }
            window.open(this.getLinkUrl(detail.selection.value), '_blank')?.focus();
        });
    }
}
